import 'honeybadger-js';
import 'lib/vendor_extensions/.modernizrrc.js';


// WEBPACK FOOTER //
// ./app/javascript/packs/head_scripts.js